import { render, staticRenderFns } from "./FormTask.vue?vue&type=template&id=6d159613&"
import script from "./FormTask.vue?vue&type=script&lang=js&"
export * from "./FormTask.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports